/* eslint-disable */
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getFollowRequest: ['userId','isFollower','params'],
  getFollowSuccess: ['response'],
  getFollowFailure: ['response']
})

export const GetFollowTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  following: {
    userId: null,
    params: null,
    pagination: null,
    fetching: null,
    data: null,
    error: null,
    timeStamp: null,
    logRef: null,
  },
  followers: {
    userId: null,
    params: null,
    pagination: null,
    fetching: null,
    data: null,
    error: null,
    timeStamp: null,
    logRef: null,
  }
})

/* ------------- Selectors ------------- */

export const GetFollowSelectors = {
  getData: state => state.data
}

/* ------------- Reducers ------------- */

// request the data from an api
export const request = (state,  { userId, isFollower, params }) => {
  let data = null
  if (isFollower) {
    if (userId == state.followers.userId) // keep older data to avoid flashing
      data = state.followers.data
    return state.merge({followers: Object.assign({}, state.followers, { fetching: true, error: false, userId, params, data})})
  }
  else {
    if (userId == state.following.userId)
      data = state.following.data
      return state.merge({following: Object.assign({}, state.following, { fetching: true, error: false, userId, params, data})})
  }
}

export const success = (state, action) => {
  console.tron.display({ name: `GetFollowRedux`, preview :`success`, value: {action} })
  const { isFollower } = action.response
  const apiResponse = action.response.data
  const { data, pagination = null, logRef } = apiResponse
  timeStamp = Date.now()
  if (isFollower)
    return state.merge({followers: Object.assign({}, state.followers, { fetching: false, error: null, data, pagination, timeStamp, logRef})})
  else
    return state.merge({following: Object.assign({}, state.following, { fetching: false, error: null, data, pagination, timeStamp, logRef})})
}

export const failure = (state, action) => {
  const { isFollower } = action.response
  if (isFollower)
    state.merge({followers: Object.assign({}, state.followers, { fetching: false, error: true, data: null})})
  else
    state.merge({following: Object.assign({}, state.following, { fetching: false, error: true, data: null})})
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_FOLLOW_REQUEST]: request,
  [Types.GET_FOLLOW_SUCCESS]: success,
  [Types.GET_FOLLOW_FAILURE]: failure
})
